(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-elevation-ranges", [], factory);
	else if(typeof exports === 'object')
		exports["map-elevation-ranges"] = factory();
	else
		root["map-elevation-ranges"] = factory();
})(self, function() {
return 